import { Col, Form, FormControl, FormGroup, Row } from "react-bootstrap";

import { useTranslateContext } from "../../contexts/translate.context";
import { isEmpty } from "../../utilities/validators";
import { EncounterType } from "../../utilities/types";

export interface IEncounterRecordProps {
    title: any,
    isEdit: boolean,
    identifier: boolean,
    viewOnly?: boolean,

    created?: any,
    updated?: any,
    setCreated?: any,
    setUpdated?: any,

    launch: any,
    norm: any,
    daily: any,
    subject: any,
    reason: any,
    resolved: any,
    participants: any,
    setLaunch: any,
    setNorm: any,
    setDaily: any,
    setSubject: any,
    setReason: any,
    setResolved: any,
    setParticipants: any
}

export const EncounterRecord: React.FC<IEncounterRecordProps> = (props: IEncounterRecordProps) => {

    const { display } = useTranslateContext();

    return (
        <>
            <Row>
                <Col sm="2">
                    <FormGroup>
                        <Form.Label htmlFor="form-launch">{display.label.date_launch}</Form.Label>
                        <FormControl id="form-launch" name="launch" placeholder={display.example.launch}
                            disabled={!props.isEdit}
                            readOnly={true}
                            value={props.launch}
                            onChange={e => props.setLaunch(e.target.value)}
                        />
                    </FormGroup>
                </Col>
                <Col sm="8">
                    <FormGroup>
                        <Form.Label htmlFor="form-norm">{display.label.norm}</Form.Label>
                        <Form.Select id="form-norm" name="norm"
                            disabled={!props.isEdit}
                            value={props.norm} 
                            onChange={e => props.setNorm(e.target.value)}
                        >
                            { isEmpty(props.norm) ? (
                                <option value="">...</option>
                            ) : null }
                            { EncounterType.map((iterator: any, idx: any) => (
                                <option key={idx} value={iterator.id}>{iterator.description}</option>
                            ))}
                        </Form.Select>
                    </FormGroup>
                </Col>
                <Col sm="2">
                    <FormGroup>
                        <Form.Label htmlFor="form-daily">{display.label.daily}</Form.Label>
                        <FormControl id="form-daily" name="daily" placeholder={display.example.daily}
                            disabled={!props.isEdit}
                            value={props.daily}
                            onChange={e => props.setDaily(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-subject">{display.label.subject}</Form.Label>
                        <FormControl id="form-subject" name="subject" placeholder={display.example.subject}
                            disabled={!props.isEdit}
                            value={props.subject}
                            onChange={e => props.setSubject(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-reason">{display.label.reason}</Form.Label>
                        <FormControl as="textarea" rows={3} id="form-reason" name="reason" placeholder={display.example.reason}
                            disabled={!props.isEdit}
                            value={props.reason}
                            onChange={e => props.setReason(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-resolved">{display.label.resolved}</Form.Label>
                        <FormControl as="textarea" rows={3} id="form-resolved" name="resolved" placeholder={display.example.resolved}
                            disabled={!props.isEdit}
                            value={props.resolved}
                            onChange={e => props.setResolved(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Form.Label htmlFor="form-participants">{display.label.participants}</Form.Label>
                        <FormControl as="textarea" rows={3} id="form-participants" name="participants" placeholder={display.example.participants}
                            value={props.participants}
                            onChange={e => props.setParticipants(e.target.value)}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </>
    );

}

export default EncounterRecord;
